import { NgModule } from '@angular/core';
import { FuseSharedModule } from '@fuse/shared.module';
import { PercentageDirective } from './directive/percentage.directive';
import { DateFormatPipe } from './pipe/date-format.pipe';
import { TitleCapitalizePipe } from './pipe/title.pipe';

@NgModule({
  declarations: [
    DateFormatPipe,
    PercentageDirective,
    TitleCapitalizePipe,
  ],
  imports: [
    FuseSharedModule,
  ],
  exports: [
    FuseSharedModule,
    DateFormatPipe,
    PercentageDirective,
    TitleCapitalizePipe,
  ],
  providers: [
    DateFormatPipe,
  ],
})
export class CoreModule {
}
